import antdEs from 'antd/lib/locale-provider/es_ES';
import esMessages from '../locales/es_ES.json';

const esLang = {
    messages: esMessages,
    antd: antdEs,
    locale: 'es',
};
export default esLang;
